import { Grid } from '@mui/material';
import React from 'react';
import { NumberInputWidget } from 'src/components/widget';
import { lang } from 'src/utils';

interface SizeBoxProps {
  width?: number;
  height?: number;
  onChange: (width?: number, height?: number) => void;
}

export const SizeBox = (props: SizeBoxProps) => {
  return (
    <Grid container justifyContent="space-between" wrap="nowrap" gap={1}>
      <NumberInputWidget
        label={lang.width}
        value={props.width}
        onChange={(value) => {
          props.onChange(value as number, props.height);
        }}
      />
      <NumberInputWidget
        label={lang.height}
        value={props.height}
        onChange={(value) => {
          props.onChange(props.width, value as number);
        }}
      />
    </Grid>
  );
};
